const config = {
	/**
	 * App
	 */
	appName: 'Sipeduli Jembrana',
	appVersion: '1.0',

	/**
	 * API
	 */
	// baseUrl: 'https://dafdukapi.laksitastartup.com', 
	baseUrl: 'https://api-sipeduli.jembranakab.go.id',
	// baseUrl: 'http://localhost:8000',
}
export default config
